export default "__VITE_ASSET__DwsP_Pmy__"